import { auth } from "@/plugins/keycloak";
import { Notify } from "quasar";

export class ApiError extends Error {
    constructor(json, ...params) {
        super(...params);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
        this.name = "ApiError";
        this.message = "API error";
        this.json = json;
    }
}

export function fetchWithHeaders(url, options = {}, onError = null) {
    const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };
    if (auth.isAuthenticated.value) {
        headers.Authorization = `Bearer ${auth.token.value}`;
    }
    const defaultOptions = {
        headers,
    };
    Object.assign(defaultOptions, options);
    return fetch(url, defaultOptions)
        .then(async r => {
            const isJson = r.headers.get("content-type")?.includes("application/json");
            if (r.status === 200 || r.status === 201) {
                if (isJson) {
                    return r.json();
                }
                return r;
            }
            if (r.status === 204) {
                return;
            }
            let json;
            try {
                json = await r.json();
            } catch (e) {
                json = { error: r.status };
            }
            if (onError) {
                onError(new ApiError(json, `API error ${r.status}`));
                return null;
            }

            Notify.create({
                type: "negative",
                position: "center",
                message: Object.keys(json)
                    .map(key => [key, json[key]])
                    .flat(Infinity)
                    .join(" "),
            });
            return null;
        })
        .catch(e => {
            Notify.create({
                type: "negative",
                position: "center",
                message: e.message,
            });
            return null;
        });
}
